import { useState, useRef, useCallback } from "react";

/**
 * Measures an element's content rect via ResizeObserver.
 * Returns { ref, width, height } — attach ref to the element you want to measure.
 */
export default function useElementSize() {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const observerRef = useRef(null);

  const ref = useCallback((node) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    if (!node) return;
    observerRef.current = new ResizeObserver((entries) => {
      const rect = entries[0]?.contentRect;
      if (rect) {
        setSize({ width: Math.round(rect.width), height: Math.round(rect.height) });
      }
    });
    observerRef.current.observe(node);
  }, []);

  return { ref, width: size.width, height: size.height };
}
